import axios from 'axios';
import $ from 'jquery';
//
$(document).ready( function() {
  // Remove Styles from Marketo Forms
	function destyleMktoForm(mktoForm, moreStyles){
		var formEl = mktoForm.getFormElem()[0],
			arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

		// remove element styles from <form> and children
		var styledEls = arrayFrom(formEl.querySelectorAll("[style]")).concat(formEl);
		styledEls.forEach(function(el) {
			el.removeAttribute("style");
		});

		// disable remote stylesheets and local <style>s
		var styleSheets = arrayFrom(document.styleSheets);
		styleSheets.forEach(function(ss) {
			if ( [mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode) ) {
				ss.disabled = true;
			}
		});

	   if(!moreStyles) {
	      formEl.setAttribute("data-styles-ready", "true");
	   }
	};

  // Simple IP validation
  function validateIpAddress(ipaddress) {
    let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (ipaddress.match(ipformat)) {
      return true;
    } else {
      return false;
    }
  }


  // Blocklist Removal
  if (document.getElementById('removeFormBlocklist')) {
		// console.log('bl');
    const removeBtnBlocklist = document.getElementById('removeBtnBlocklist');
    const rmForm = document.getElementById('removeFormBlocklist');

    function fireRemovalMessage(status, message) {
      // Set message
      $('#removeMessage').html(message);
      // Set color class
      if (status === 'success') {
        $('#removeResults').addClass('off-bl').removeClass('on-bl');
      } else {
        $('#removeResults').addClass('on-bl').removeClass('off-bl');
      }
      $('#removeResultsWrapper').show();
      $('#removeMessage').show();
      $('.rpLoaderWrapper').hide();
    }

    rmForm.addEventListener('submit', function(e) {
      e.preventDefault();
			console.log('fire');
			let removeInputBlocklist = $('#removeInputBlocklist').val();
      $('.block-list-results').hide();
      $('#removeResultsWrapper').show();
			$('#rpLoaderWrapper').show();
			//
      if (validateIpAddress(removeInputBlocklist)) {
        // Get data from API
        axios.post('https://api.returnpath.com/v2/sender-score/blocklist/'+ removeInputBlocklist + '/removal', {crossDomain: true})
        .then(response =>  {
          let message = 'The IP: ' + removeInputBlocklist + ' has been submitted for removal.';
          let status = 'success';
          fireRemovalMessage(status, message);
        })
        .catch(function (error) {
          let message = 'That IP address is not currently listed in any Return Path-hosted blocklist.';
          let status = 'fail';
          fireRemovalMessage(status, message);
        });
      } else {
        let message = 'Please enter a valid IP address.';
        let status = 'error';
        fireRemovalMessage(status, message);
      }
    });
  }

	  // Blocklist Main
	  // if (document.getElementById('lookupFormBlocklist')) {
		//
	  //   MktoForms2.whenRendered(function(form) {
	  // 	  destyleMktoForm(form);
	  // 	});
		//
	  //   const lookupBtnBlocklist = document.getElementById('lookupBtnBlocklist');
	  //   const blForm = document.getElementById('lookupFormBlocklist');
	  //   let submitted = false;
		//
	  //   blForm.addEventListener('submit', function(e) {
	  //     e.preventDefault();
	  //     let lookupInputBlocklist = $('#lookupInputBlocklist').val();
	  //     $('#ssBlacklistSuccess').hide();
	  //     $('.rpLoaderWrapper').show();
	  //     $('#bl-reasons').empty();
		//
	  //     // Get data from API
	  //     axios.get('https://api.returnpath.com/v2/sender-score/blocklist/'+ lookupInputBlocklist, {crossDomain: true})
	  //     .then(response =>  {
	  //       if (response.data.blacklisted) {
	  //         $('#bl-message').html('That IP address is currently listed in a Return Path-hosted blocklist. Below is a list of reasons.');
	  //         $('#ssBlacklistSuccess').addClass('on-bl').removeClass('off-bl');
	  //         $.each(response.data.reasons, function(key, value) {
	  //           $('#bl-reasons').append('<li>' + value + '</li>');
	  //         });
	  //         $('#bl-info').show();
	  //       } else {
	  //         $('#bl-message').html('That IP address is not currently listed in any Return Path-hosted blocklist.');
	  //         $('#ssBlacklistSuccess').addClass('off-bl').removeClass('on-bl');
	  //         $('#bl-info').hide();
	  //       }
	  //       $('#ssBlacklistSuccessWrapper').show();
	  //       $('#ssBlacklistSuccess').show();
	  //       $('.rpLoaderWrapper').hide();
	  //     })
	  //   });
	  // }
});
